<script setup lang="ts">
import { storeToRefs } from 'pinia';
import useLocale from '../../composables/useLocale';
import useUiStore from '../../stores/ui';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLockKeyhole } from '@fortawesome/pro-regular-svg-icons';
library.add(faLockKeyhole);

type Props = {
  showTooltips?: boolean;
};
withDefaults(defineProps<Props>(), {
  showTooltips: true,
});

const { t } = useLocale();
const uiStore = useUiStore();
const { lockScreenAvailable, isControlsVisible, isChevronsVisible } = storeToRefs(uiStore);
const { toggleVisibleLockScreenOverlay } = uiStore;

const onLock = () => {
  toggleVisibleLockScreenOverlay(true);
  isControlsVisible.value = false;
  isChevronsVisible.value = false;
};
</script>

<template>
  <div class="d-flex mt-1">
    <v-sheet class="bg-transparent">
      <v-btn
        v-if="lockScreenAvailable"
        id="lock-screen-btn"
        data-testid="bp-lock-screen-btn"
        color="on-primary"
        variant="text"
        :ripple="false"
        icon
        :aria-label="t('label_lock_screen')"
        @click="onLock"
        size="48"
      >
        <FontAwesomeIcon size="xl" icon="fa-regular fa-lock-keyhole" />
        <v-tooltip :disabled="!showTooltips" activator="parent" location="bottom" :text="t('label_lock_screen')" />
      </v-btn>
    </v-sheet>
  </div>
</template>

<style scoped lang="scss"></style>
